import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';
import isEqual from 'lodash/isEqual';

import {
  SubActions,
  isProvisioning,
  hasProvisioningFailed,
} from 'Redux/thunks/subscriptions.thunks';
import { ExternalLink } from 'Common/Links/ExternalLink';

import { SubscriptionAvatarContainer } from './SubscriptionAvatar.container';
import SubscriptionButtons from '../components/subscription-buttons';
import { Card } from '../components/card/Card.view';
import { SubscriptionCard } from '../components/subscription-card/SubscriptionCard.view';

import { findDefaultUrl } from '../utils/subscription.utils';

const isInvite = (sub) => get(sub, 'supported-operations.accept_invitation.enabled', false);
const isUsable = (sub) => !isProvisioning(sub) && !isInvite(sub);

class SubscriptionCardContainer extends React.Component {
  constructor(props) {
    super(props);

    this.onClick = () => {
      this.props.router.push(`/subscription/${this.props.sub.id}`);
    };

    this.state = {
      isInvite: isInvite(this.props.sub),
      isUsable: isUsable(this.props.sub),
    };
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps, this.props))
      this.setState({
        isInvite: isInvite(this.props.sub),
        isUsable: isUsable(this.props.sub),
      });
  }

  render() {
    const sub = this.props.sub;
    const connectionUrl = findDefaultUrl(sub);
    const actions = <SubscriptionButtons sub={this.props.sub} />;
    const asideActions = [];

    if (this.state.isInvite) {
      asideActions.push('You are invited to join');
    }

    if (!this.state.isInvite && sub.url) {
      asideActions.push(
        <ExternalLink href={sub.url} key="documentation">
          Documentation
        </ExternalLink>
      );
    }

    const badges = isProvisioning(sub)
      ? { 'in-progress': 'Provisioning' }
      : hasProvisioningFailed(sub)
        ? { 'provisioning-failed': 'Provisioning failed' }
        : undefined;

    const Avatar = (
      <SubscriptionAvatarContainer
        connectionUrl={connectionUrl}
        customConnectionURL={this.props.customConnectionURL}
        subId={sub.id}
        withLink={true}
        name={sub.name}
      />
    );

    return (
      <SubscriptionCard
        actions={actions}
        asideActions={asideActions}
        badges={badges}
        onClick={this.onClick || null}
        text={sub.description}
        type={this.state.isInvite ? 'success' : 'default'}
        testid={this.props.testid}
        avatar={Avatar}
      />
    );
  }
}

SubscriptionCardContainer.propTypes = {
  onAccept: PropTypes.func.isRequired,
  onDecline: PropTypes.func.isRequired,
  router: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  sub: PropTypes.object.isRequired,
  customConnectionURL: PropTypes.string,
};

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onAccept: () => dispatch(SubActions.accept(ownProps.sub.id)),
    onDecline: () => dispatch(SubActions.decline(ownProps.sub.id)),
  };
}

const Connected = connect(null, mapDispatchToProps)(withRouter(SubscriptionCardContainer));

export { Connected as SubscriptionCardContainer };
